<template>
  <v-row>
    <v-col cols="6" v-for="ticket in tickets.list" :key="ticket">
      <v-card :color="getCardColor(ticket)" style="height: 100%">
        <template v-slot:prepend>
          <v-icon :icon="['fas', getIcon(ticket['ВидСервиса'])]" />
        </template>
        <template v-slot:append>
          <v-icon :icon="['fas', 'user-gear']" />&nbsp;
          <strong v-if="ticket['Исполнитель']">{{ ticket['Исполнитель'].replace(/(\S+) (\S)\S* (\S)\S*/, "$1 $2. $3.") }}</strong>
          <span v-else>Не указан</span>
        </template>
        <template v-slot:title>
          <span v-if="ticket['Документ'] === 'Обращение'">
            <strong>{{ ticket['Номер'] }}</strong>
            <v-chip style="rotate: -20deg; position: absolute; right: 2px; bottom: 12px;" inline color="light-green" density="compact" v-if="isNew(ticket)">
            <template v-slot:default>
              <NewWord />
            </template>
          </v-chip>
          </span>
          <span v-if="ticket['Документ'] === 'ТОиППР'">
            <strong>{{ticket['ВидСервиса']}}</strong>
          </span>
        </template>
        <template v-slot:text>
          <div v-if="ticket['Местонахождение'] || ticket['ФизОбъект']">
            <p class="my-cords"><span v-if="ticket['ФизОбъект']">
              <v-icon icon="fa-solid fa-map-location-dot" />&nbsp;{{ticket['ФизОбъект']}}</span>
              <span v-if="ticket['Местонахождение']"> - {{ ticket['Местонахождение'] }}</span>
            </p>
          </div>
          <v-divider v-if="ticket['Документ'] === 'Обращение'" class="ml-0 mr-0 mt-1 mb-1" />
          <div v-if="ticket['Документ'] === 'Обращение'">
            <strong>Описание:</strong>&nbsp;{{ ticket['Описание'] }}
          </div>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import NewWord from "@/components/Dashboard/Misc/NewWord.vue";

export default {
  name: "C_InWork",
  components: {NewWord},
  props: ['tickets'],
  methods: {
    isNew: function (ticket) {
      let is_new = true
      if (ticket['Решение'] && ticket['Решение'] !== "") {
        is_new = false
      }
      if (ticket['РезультатыДиагностики'] && ticket['РезультатыДиагностики'] !== "") {
        is_new = false
      }
      if (ticket['Предложения'] && ticket['Предложения'] !== "") {
        is_new = false
      }
      if (ticket['ДопИнформация'] && ticket['ДопИнформация'] !== "") {
        is_new = false
      }
      return is_new
    },
    getIcon: function (type) {
      switch (type) {
        case 'Инцидент (аварийное обращение)':
          return 'triangle-exclamation'
        case 'Заявка на дополнительные / прочие работы':
          return 'toolbox'
        case 'Заявка на отчет, инструктаж, помощь':
          return 'chalkboard-user'
        case 'Заявка на СМР / ПНР':
          return 'helmet-safety'
        case 'Заявка на испытание':
          return 'hand-holding-hand'
        case 'Заявка на техническое обслуживание':
          return 'hand-holding-medical'
        default:
          return 'circle-notch'
      }
    },
    getCardColor: function (ticket) {
      let color = ''
      if (this.isNew(ticket)) {
        color = 'light-green-lighten-4'
      }
      if (ticket['Документ'] === 'Обращение' && (ticket['ВидСервиса'] === 'Заявка на техническое обслуживание' || ticket['ВидСервиса'] === 'Заявка на испытание')) {
        color = 'transparent'
      }
      if (ticket['Документ'] === 'ТОиППР') {
        color = 'grey-lighten-3'
      }
      return color
    }
  }
}
</script>

<style scoped>

</style>